const DELVE_TIME_REGEXP = new RegExp(/(?:(?:\d){1,2}:){1,2}(?:(?:\d){1,2})+/);
const SPECIAL_CHARACTERS = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŒœŠšŸƒ"

module.exports = {
    // Delve Timestamp Regexp
    DELVE_TIME_REGEXP: DELVE_TIME_REGEXP.source,
    ARROW_TIME_REGEXP: new RegExp(/[\ \d:,.]*[ \-]+>+[\ \d:,.]*/).source,
    NAME_REGEX: new RegExp(`[a-zA-Z${SPECIAL_CHARACTERS}][\\w.${SPECIAL_CHARACTERS}]*(?: [\\w.${SPECIAL_CHARACTERS}]+){0,2}`).source,
    BLANK_REGEX: new RegExp(/[ \t]*/).source,
}